import { IMeeting, ceilMeasure } from '@utils';
import React, { FC, useMemo } from 'react';
import { Monitor } from '../../svgs';

interface IndiatorProps {
  meeting?: IMeeting;
  height: number;
  visible: boolean;
}

export const Indicator: FC<IndiatorProps> = ({ meeting, height, visible }) => {
  const bottom = useMemo(() =>
    height < 40 / ceilMeasure ? 2 : 11
    , [height]);

  return !!meeting.format && height >= 30 / ceilMeasure && visible && (
    <div
      className="indicator"
      style={{ bottom }}
    >
      {meeting.format === 'OFFLINE'
        ? <div className="cabinet">
          {meeting.room?.cabinetNumber}
        </div>
        : <Monitor />
      }
    </div>
  );
};
